import { API_ORIGIN, authorizedFetch } from '@yeshuman/sdk'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'


export function useApplicationNudge(opportunityId: string | undefined) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (applicationId: string) => {
      const response = await authorizedFetch(
        `${API_ORIGIN}/api/applications/${encodeURIComponent(applicationId)}/nudge/`,
        { method: 'POST' },
      )
      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        throw new Error(typeof data.error === 'string' ? data.error : 'Failed to nudge candidate')
      }
      return data as { application_id: string; nudged_at: string }
    },
    onSuccess: () => {
      if (opportunityId) {
        void queryClient.invalidateQueries({ queryKey: ['opportunity-applicants', opportunityId] })
      }
      toast.success('Reminder sent')
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
